// Safari-safe autoplay for hero videos.
// Safari blocks autoplay unless `muted` + `playsInline` are set as JS properties
// and the video is visible (Swiper's fade effect hides inactive slides). We
// prep every hero video, then drive play/pause off Swiper's slide events.
// Mobile: cover the blocked video with its poster. Keeps the video element
// so scroll/click still triggers playback; overlay auto-removes on playing.
function showPosterOverlay(video) {
  if (!video || !video.poster || !video.parentNode) return;
  if (video.dataset.posterOverlay === '1') return;
  video.dataset.posterOverlay = '1';
  var overlay = document.createElement('div');
  overlay.className = 'herovideo-poster-overlay';
  overlay.style.cssText =
    'position:absolute;inset:0;background-image:url(' + video.poster +
    ');background-size:cover;background-position:center;pointer-events:none;z-index:2;';
  var parent = video.parentNode;
  if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
  parent.appendChild(overlay);
  video._posterOverlay = overlay;
  var hide = function () {
    if (video._posterOverlay) {
      video._posterOverlay.remove();
      video._posterOverlay = null;
    }
    video.removeEventListener('playing', hide);
  };
  video.addEventListener('playing', hide);
}

// Desktop: replace the <video> with its poster as an <img>. On desktop the
// user typically won't scroll the hero, so a static image is cleaner than
// waiting for interaction.
function swapToPoster(video) {
  if (!video || !video.poster || !video.parentNode) return;
  if (video.dataset.posterSwapped === '1') return;
  video.dataset.posterSwapped = '1';
  var img = document.createElement('img');
  img.src = video.poster;
  img.className = video.className;
  img.alt = '';
  img.setAttribute('aria-hidden', 'true');
  video.replaceWith(img);
}

function handleBlockedVideo(video) {
  var isMobile = window.matchMedia('(max-width: 989px)').matches;
  if (isMobile) showPosterOverlay(video);
  else swapToPoster(video);
}

function forcePlay(video) {
  if (!video) return;
  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;
  video.setAttribute('muted', '');
  video.setAttribute('playsinline', '');
  video.removeAttribute('controls');
  var p = video.play();
  if (p && typeof p.catch === 'function') {
    p.catch(function () {
      var retry = function () {
        video.play().catch(function () {});
        video.removeEventListener('canplay', retry);
        video.removeEventListener('loadeddata', retry);
      };
      video.addEventListener('canplay', retry);
      video.addEventListener('loadeddata', retry);
      // If still paused after a grace period, autoplay is blocked.
      // Desktop → swap to <img>; Mobile → overlay (still plays on scroll).
      setTimeout(function () {
        if (video.paused && video.currentTime === 0) handleBlockedVideo(video);
      }, 1500);
    });
  }
}

function prepHeroVideos() {
  document.querySelectorAll('.herovideo').forEach(function (v) {
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.removeAttribute('controls');
    // Preload enough to autoplay immediately when the slide becomes active.
    if (v.preload === 'none') v.preload = 'auto';
    forcePlay(v);
  });
}

function playActiveHeroVideo() {
  var slide = document.querySelector('.heroimgslider .swiper-slide-active');
  if (!slide) return;
  var video = slide.querySelector('video.herovideo');
  if (video) forcePlay(video);
}

prepHeroVideos();

const heroimgslider = new Swiper('.heroimgslider', {
  effect: 'fade',
  fadeEffect: { crossFade: true },
  autoplay: { delay: sliderspeed },
  simulateTouch: false,
  allowTouchMove: false,
  speed: 500,
  on: {
    init: playActiveHeroVideo,
    slideChangeTransitionStart: playActiveHeroVideo,
    slideChangeTransitionEnd: playActiveHeroVideo,
  },
});

$('video').attr('oncontextmenu', 'return false;');

// Unlock on first user gesture as a last-resort fallback.
(function () {
  var unlock = function () {
    document.querySelectorAll('.herovideo').forEach(forcePlay);
    document.removeEventListener('touchstart', unlock);
    document.removeEventListener('click', unlock);
    document.removeEventListener('scroll', unlock);
  };
  document.addEventListener('touchstart', unlock, { passive: true });
  document.addEventListener('click', unlock);
  document.addEventListener('scroll', unlock, { passive: true });
  window.addEventListener('pageshow', playActiveHeroVideo);
})();